import React from 'react';
import PropTypes from 'prop-types';
import { TableHeaderRow } from '@devexpress/dx-react-grid-bootstrap3';

const TableHeaderComponent = ({
	column, children, ...restProps
}) => (
	<TableHeaderRow.Content
		column={column}
		{...restProps /* eslint-disable-line react/jsx-props-no-spreading */}
	>
		<div className={column.name === 'job' ? 'padding-left-20' : ''}>
			{children}
		</div>
	</TableHeaderRow.Content>
);

TableHeaderComponent.propTypes = {
	children : PropTypes.any,
	column   : PropTypes.object.isRequired,
};

TableHeaderComponent.defaultProps = {
	children : undefined,
};

export default TableHeaderComponent;
